import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { UserListTable } from '@/features/users/components/UserListTable';

export const Route = createFileRoute('/_auth/users/')({
  component: () => (
    <ErrorBoundary moduleName="Users">
      <Suspense fallback={<PageLoader />}>
        <UserListTable
          title="All Users"
          userTypeIds={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
          showAllTypes
        />
      </Suspense>
    </ErrorBoundary>
  ),
});
